/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface UiTableHeaderLabelProps {
    children: React.ReactNode
    className?: string
}

const getHeaderLabelTitle = (children: React.ReactNode): string | undefined => {
    if (typeof children === 'string' || typeof children === 'number') {
        return String(children)
    }

    return undefined
}

const UiTableHeaderLabel = (props: UiTableHeaderLabelProps) => {
    const title = getHeaderLabelTitle(props.children)

    return (
        <span
            title={title}
            className={clsx(
                'UiTableHeaderLabel block text-xs font-medium tracking-wider leading-3 uppercase text-gray-600 dark:text-gray-200 truncate',
                props.className
            )}
        >
            {props.children}
        </span>
    )
}

export default UiTableHeaderLabel
